export default __webpack_public_path__ + "static/media/save.3ca1efd1.svg";